import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class NormalButtonBackendClass extends Component {
  render() {
    const {
      className = "",
      label = "",
      onClick,
      id,
      disabled = false,
      outline = false,
      mainbg = false,
      link = false,
      normal = false,
      success = false,
      danger = false,
      mainbgrev = false,
      applybg = false,
      resetbg = false,
      styleOne = false,
      styleTwo = false,
      styleThree = false,
      styleFour = false,
      styleFive = false,
      submitBtn = false,
      couponBtn = false,
      rightIcon = "",
      leftIcon = "",
      buttonClass = "",
      t,
      isActive,
    } = this.props;

    return (
      <div className={`${buttonClass}`}>
        <button
          id={id}
          className={`btn cursor-pointer text-gray-700 border-gray-400 hover:text-white hover:border-blue-500 ${
            outline ? "outline-btn" : ""
          } ${danger ? "danger-btn" : ""} ${mainbg ? "backbg-btn" : ""} ${
            normal ? "normal-btn" : ""
          } ${link ? "delete-btn" : ""} ${success ? "success-btn" : ""} ${
            mainbgrev ? "mainbgreverse-btn" : ""
          } ${isActive ? "border-primary text-primary " : ""}
              ${applybg ? "applybgreverse-btn" : ""}
              ${resetbg ? "resetbgreverse-btn" : ""} 
              ${styleOne ? "styleOne-btn" : ""} 
              ${styleTwo ? "styleTwo-btn" : ""} 
              ${styleThree ? "styleThree-btn" : ""} 
              ${styleFour ? "styleFour-btn" : ""} 
              ${styleFive ? "styleFive-btn" : ""} 
              ${submitBtn ? "submit-btn" : ""}
              ${couponBtn ? "coupon-btn" : ""}
              ${className}`}
          onClick={onClick}
          disabled={disabled}
        >
          {leftIcon !== "" ? (
            <img src={leftIcon} width="25" alt="s" className="p-1" />
          ) : (
            ""
          )}
          {t(label)}
          {rightIcon !== "" ? (
            <span className={`btn-right-icon ${rightIcon} p-1`}></span>
          ) : (
            ""
          )}
        </button>
      </div>
    );
  }
}
export const NormalButtonBackend = withTranslation()(NormalButtonBackendClass);
